import { Call } from 'starknet';
import { getConfigManager } from '../../config/getConfigManager';
import { Decimal } from '../../datastructures';
import { MultiCallContract } from '../../services';
import { MULTICALL_CONTRACT_ADDRESS, POOL_LP_TOKEN_DECIMALS } from '../../constants';
import { createAsyncAtom } from '../../lib/state';
import rpcProviderAtom from '../rpcProviderAtom';

const RESPONSE_CHUNK_SIZE = 3;

const poolsLPTokenTotalSupplyAtom = createAsyncAtom(
  async get => {
    const provider = await get(rpcProviderAtom);

    const pools = getConfigManager().getConfig().pools;

    const totalSupplyMap: { [pairId: string]: Decimal } = {};

    const calldata: Call[] = Object.entries(pools).map(([, poolConfig]) => ({
      contractAddress: poolConfig.pair.address,
      entrypoint: 'totalSupply',
      calldata: [],
    }));

    const multiCallContract = new MultiCallContract(MULTICALL_CONTRACT_ADDRESS, provider);

    const result = await multiCallContract.aggregate(calldata);
    if (!result) {
      return {};
    }

    for (let i = 0; i < result.length; i += RESPONSE_CHUNK_SIZE) {
      const [, poolsConfig] = Object.entries(pools)[i / RESPONSE_CHUNK_SIZE];

      // Index 1,2 is totalSupply
      const totalSupply = new Decimal({ low: result[i + 1], high: result[i + 2] }, POOL_LP_TOKEN_DECIMALS);

      totalSupplyMap[poolsConfig.pair.id] = totalSupply;
    }

    return totalSupplyMap;
  },
  10000,
  ['pool-deposit', 'pool-withdraw', 'user-refresh'],
);

export default poolsLPTokenTotalSupplyAtom;
